// import { basicStyle, parallaxStyle } from './styles'
import { isEmpty } from 'lodash'
import { basicStyle, parallaxStyle } from '../Hero/styles'
import { getBgImage, getBgPosition } from '../Hero/functions'

const INITIAL_DATA = { containerStyles: '', backgroundStyle: {}, isDesktop: true }

export const getHeroData = ({ data, isMobile, isTablet, isDesktop }) => {
  if (isEmpty(data)) return INITIAL_DATA

  const parallax = data?.background?.parallax

  const containerStyles = parallax ? parallaxStyle : basicStyle

  const bgImage = getBgImage({ isMobile, isTablet, background: data?.background })
  const backgroundPosition = getBgPosition({ isMobile, isTablet, background: data?.background })

  const backgroundStyle = {
    backgroundImage: bgImage,
    backgroundPosition,
    display: 'grid',
    gridTemplateRows: '1fr',
  }

  const rows = isDesktop ? data?.rows : data?.rows_for_mobile

  return { containerStyles, backgroundStyle, isDesktop, rows }
}

export const getValue = (value) => {
  if (!value) return ''

  return value
}
